import { atom } from "jotai";

const contractAtom = atom();
export default contractAtom;